<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formOrderAdjustment">
        <div class="p-2">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="orderAdjustmentContract.userNameCreate"
                [createDate]="orderAdjustmentContract.createDate"
                [userNameUpdate]="orderAdjustmentContract.userNameUpdate"
                [updateDate]="orderAdjustmentContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <!-- Formulario Captura -->
          <div class="row mt-1 d-flex justify-content-between">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [required]="true"
                    [recovery]="true" [list]="listBranches"
                    (onChangeSelect)="changeBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                  <app-custom-input-number formControlName="consecutive" [required]="true" [recovery]="true"
                    [labelText]="'Pedido'" (onChangeNumber)="changeConsecutive($event)">
                  </app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-4 col-12">
                  <app-custom-select formControlName="orderTypeId" [labelText]="'Tipo'" [required]="true"
                    [list]="listTypes">
                  </app-custom-select>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                  <app-custom-datepicker formControlName="dateOrder" [labelText]="'Fecha'" [required]="true">
                  </app-custom-datepicker>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                  <app-custom-input-text formControlName="purchaseOrderNumber" [labelText]="'Nro.O.Compra'">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-10">
                  <app-custom-tag [label]="'Estado Pedido'" [severity]="severityState"
                    [value]="stateText"></app-custom-tag>
                </div>
                <div class="col field-button-state">
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [required]="true"
                    [list]="listClients">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'" [required]="true"
                    [list]="listCostCenters"></app-custom-autocomplete>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="sellerId" [labelText]="'Vendedor'" [required]="true"
                    [list]="listSellers"></app-custom-autocomplete>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                  <app-custom-input-text formControlName="advertiser" [labelText]="'Anunciante'">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-5 col-md-6 col-sm-6 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                    [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-5 col-md-6 col-sm-6 col-12">
                  <app-custom-textarea formControlName="observationRemission" [labelText]="'Observación Remisión'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-order-adjustment-detail [orderAdjustmentModel]="orderAdjustmentContract" [disableAllDetail]="disableAllDetail"
      [disablePartial]="disablePartial">
    </app-order-adjustment-detail>
  </div>
</section>
<!-- Impresión -->
<app-print-order id="print-order" [companyId]="companyId" [reloadPrint]="reloadPrint"
  [orderPrintModel]="orderPrintModel" [focusText]="false" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-order>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>